import React, { useState, useEffect } from "react";
import { array, string } from "prop-types";
import get from "lodash/get";

import LeftImageRightNews from "../../../molecules/LeftImageRightNews";
import DfpAd from "../../../dfp-ad";

import "./row1.m.css";

const Row1 = ({ stories, collectionSlug, lang, adSlotId = "" }) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [firstStory] = stories;
  let heroImage = false;
  if (get(stories[0].story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"])) {
    heroImage = true;
  } else if (stories[0].story["hero-image-s3-key"]) {
    heroImage = true;
  }

  useEffect(() => {
    global.deviceWidth > 1263 && setIsDesktop(!isDesktop);
  }, []);

  return (
    <div styleName={`base ${heroImage ? "" : "no-image"}`}>
      <LeftImageRightNews story={firstStory.story} showExcerpt={true} cssStyleName="bigSize" widths={[300]} />
      {!isDesktop && (
        <div styleName="ad-slot">
          <DfpAd
            adtype={lang === "en" ? "EnPalo_HP_336x280_R1" : "Home_336x280_R1"}
            collectionSlug={collectionSlug}
            layoutName="FourteenStories2AdBigFact"
            slotId={adSlotId}
          />
        </div>
      )}
    </div>
  );
};

Row1.propTypes = {
  stories: array.isRequired,
  collectionSlug: string,
  lang: string,
  adSlotId: string,
};

export default Row1;
